import React, { useState } from 'react';
import { Turl } from '../components/tUrl.js';
import '../css/emailVerificationFlow.css'; // Стили остаются теми же
import { t } from 'ttag';
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js';

const tg = window.Telegram ? window.Telegram.WebApp : null;

const sendTradeCode = async (amount) => {
    const _userData = tg ? tg.initData : null;
    let userData = { initData: _userData, amount: amount, type: 2 };

    const response = await fetch(Turl + '/st/send-trade-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
    });
    return response.json();
};

const submitTradeWithdrawal = async (amount, code) => {
    const _userData = tg ? tg.initData : null;
    let userData = {
        initData: _userData,
        code: code,
        amount: parseFloat(amount)
    };

    const response = await fetch(Turl + '/st/trade-withdraw', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
    });
    return response.json();
};

const Withdraw = ({ recData }) => {
    const [step, setStep] = useState('enter_amount'); // 'enter_amount', 'enter_code', 'confirmed'
    const [amount, setAmount] = useState('');
    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleAmountSubmit = async (e) => {
        e.preventDefault();

        if (parseFloat(amount) < 10) {
            setError(t`Amount must be greater than 10 usdt.`);
            return;
        }
        if (parseFloat(amount) > recData.trade_balance) {
            setError(t`Not enough funds on balance.`);
            return;
        }

        setIsLoading(true);
        setError('');

        const response = await sendTradeCode(amount);

        setIsLoading(false);
        if (response.success) {
            setStep('enter_code'); // Переходим к шагу ввода кода
        } else {
            setError(response.message || t`Failed to send code. Please try again.`);
        }
    };

    // Этот обработчик теперь отправляет данные без email
    const handleCodeSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        // ‼️ Вызываем новую функцию без email
        const response = await submitTradeWithdrawal(amount, code);

        setIsLoading(false);
        if (response.success) {
            setStep('confirmed');
            setTimeout(() => {
                window.location.reload(); // Обновляем страницу после успеха
            }, 1000);
        } else {
            setError(response.message || t`Error. Invalid code.`);
        }
    };

    // --- Рендеринг в зависимости от текущего шага ---

    if (step === 'confirmed') {
        return (
            <div className="Email-block">
                <div>
                    <h2 style={{ color: '#4cdf4c' }}>✓ {t`Successfully!`}</h2>
                    {/* ‼️ УБРАЛИ EMAIL */}
                    <p>{t`Your withdrawal of`} <strong>{amount} USDT</strong> {t`is confirmed.`}</p>
                </div>
            </div>
        );
    }

    if (step === 'enter_code') {
        return (
            <div className="Email-block">
                <h2>{t`Email Confirmation`}</h2>
                <p>
                    {t`We sent a code to your registered email.`}<br />
                    {t`You are withdrawal`} <strong>{amount} USDT</strong>.
                </p>
                <form onSubmit={handleCodeSubmit}>
                    <div className='email-enter'>
                        <label htmlFor="code">{t`Verification code:`}</label>
                        <input
                            type="text"
                            id="code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="123456"
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className='email-enter'>
                        <button type="submit" disabled={isLoading || code.length < 6}>
                            {isLoading ? t`Checking...` : t`Confirm & Send`}
                        </button>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                    <button
                        type="button"
                        onClick={() => { setStep('enter_amount'); setError(''); }}
                        className="link-button"
                    >
                        {t`Change amount`}
                    </button>
                </form>
            </div>
        );
    }

    // --- Шаг 1: Ввод суммы ---
    return (
        <>
            {/* Блок Баланса */}
            <div className="f-balance-card">
                <div className="f-balance-label">{t`Balance`}</div>
                <div className="f-balance-value">{formatNumberWithCommas(recData.trade_balance, 2)} USDT</div>
            </div>

            <div className="Email-block">
                <h2>{t`Enter the amount you want to withdraw from the trade`}</h2>
                <p>{t`We will send a confirmation code to your email.`}</p>
                <form onSubmit={handleAmountSubmit}>

                    <div className='email-enter'>
                        <label htmlFor="amount">{t`Amount:`}</label>
                        <input
                            type="number"
                            id="amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="100.00"
                            required
                            disabled={isLoading}
                        />
                    </div>

                    <div className='email-enter'>
                        <button
                            type="submit"
                            disabled={isLoading || !amount || parseFloat(amount) <= 0}
                        >
                            {isLoading ? t`Sending...` : t`Send code`}
                        </button>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                </form>
            </div>
        </>
    );
};

export { Withdraw };